const resumo_da_escola = [
  {
    path: "/resumo-da-escola",
    redirect: "/resumo-da-escola",
    meta: {
      breadCrumb: "Gestão - Apoio Gerencial Gestão de Classe",
    },
    children: [
      {
        path: "/resumo-da-escola",
        name: "resumo-da-escola",
        component: () => import("@/views/ResumoDaEscola/ResumoDaEscola.vue"),
      },
    ],
  },
];

export { resumo_da_escola };
